var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 3.04306 0.501062 2.37565 0.568765 1.87208C0.634534 1.3829 0.754831 1.12385 0.93934 0.93934C1.12385 0.754831 1.3829 0.634534 1.87208 0.568765C2.37565 0.501062 3.04306 0.5 4 0.5H4.34315C5.20144 0.5 5.49131 0.50885 5.7456 0.614181C5.99989 0.719511 6.21111 0.918218 6.81802 1.52513L7.47487 2.18198C7.49758 2.20469 7.51997 2.2271 7.54208 2.24923C8.05461 2.76225 8.4108 3.11878 8.87172 3.3097C9.33263 3.50062 9.8366 3.50038 10.5618 3.50003C10.5931 3.50002 10.6247 3.5 10.6569 3.5H12C12.9569 3.5 13.6244 3.50106 14.1279 3.56876C14.6171 3.63453 14.8762 3.75483 15.0607 3.93934C15.2452 4.12385 15.3655 4.3829 15.4312 4.87208C15.4989 5.37565 15.5 6.04306 15.5 7V10C15.5 10.9569 15.4989 11.6244 15.4312 12.1279C15.3655 12.6171 15.2452 12.8762 15.0607 13.0607C14.8762 13.2452 14.6171 13.3655 14.1279 13.4312C13.6244 13.4989 12.9569 13.5 12 13.5H4C3.04306 13.5 2.37565 13.4989 1.87208 13.4312C1.3829 13.3655 1.12385 13.2452 0.93934 13.0607L0.59441 13.4056L0.93934 13.0607C0.754831 12.8762 0.634534 12.6171 0.568765 12.1279C0.501062 11.6244 0.5 10.9569 0.5 10V4Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.5b4b6603c10dc9e6fc57b089b21bce07.svg";
export { ForwardRef as ReactComponent };